import React from "react";

import { ROUTE_SIMS, ROUTE_BLOG, ROUTE_SEARCH } from "../../routes";

import { StyledSearchIcon } from "../../components/public/navbar/styledNavbars";

const links = [
  {
    id: 2,
    title: "آزمایش‌ها",
    path: ROUTE_SIMS,
    className: "search",
  },
  {
    id: 3,
    title: "بلاگ",
    href: ROUTE_BLOG,
  },
  // TODO: #Future feature
  // {
  //   id: 4,
  //   title: "مسابقات",
  //   path: "/tournaments", // TODO: Create tournaments route when it's UI is completed
  // },
  {
    id: 5,
    title: <StyledSearchIcon size="25" />,
    path: ROUTE_SEARCH,
  },
];
export default links;
